import React, { useEffect, useState, useRef } from 'react';
import FilterComponents from '../../../product/components/FilterComponents.tsx';
import CustomDataGrid from '../../../components/CustomDataGrid/CustomDataGrid.tsx';
import axios from 'axios';
import jwt_decode from 'jwt-decode';
import { Button, Grid, Box, Modal, Typography, Paper } from '@mui/material'
import edit from './../../../../assets/icons/edit.png'
import AddRestaurantDialog from '../AddRestaurantDialog/AddRestaurantDialog.tsx';
import EditEmployeeDialog from '../EditEmployeeDialog/EditEmployeeDialog.tsx';
import pencilIcon from './../../../../assets/icons/editPencil.png'
import VATEditDialog from '../VATEditDialog/VATEditDialog.tsx';
import EditKitchenDialog from '../EditKitchenDialog/EditKitchenDialog.jsx';
import bin from './../../../../assets/icons/recycle-binColor.png'
import SweetAlertModal from '../../../components/SweetAlertModal/SweetAlertModal.js';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import { Swiper, SwiperSlide } from "swiper/react";
//import RightArrow from "../../../../assets/icons/right-arrow.png";
//import LeftArrow from "../../../../assets/icons/left-arrow.png";

import RightArrow from "../../../../assets/icons/right-arrow.png";
import LeftArrow from "../../../../assets/icons/left-arrow.png";

function KitchenSetupPage(props) {

    const [openConfirmaitonModal, setopenConfirmaitonModal] = useState(false)
    const apiAddress = process.env.REACT_APP_SECRET;
    const loadData = async (data) => {
        const token = localStorage.getItem('token');
        var decodedData = {};
        if (token != null) {
            try {
                decodedData = jwt_decode(token)

                var obj = {
                    id: decodedData.UserId,
                    title: decodedData.UserName
                }
            } catch (error) {
            }

        }
        const restaurant = JSON.parse(localStorage.getItem('restaurant'));



        // 'https://localhost:7175/api/Kitchen/GetAllKitchensByRestaurantId/123
        axios
            .get(`${apiAddress}/api/Kitchen/GetAllKitchensByRestaurantId/${data.id}`)
            .then((response) => {
                console.log("im date", response.data);
                var list = [];
                // list.push(response.data)
                // setRestaurantDatas(list);
                response.data.map((dt, i) => {
                    var obj = {
                        id: dt.id,
                        name: dt.name,
                        address: dt.printerIpAddress,
                        PhoneNumber: dt.mobileNo,
                        Email: dt.emailAddress,
                        maxQueuedSize: dt.maxQueuedSize,
                        queuedMaxTime: dt.queuedMaxTime
                    }
                    list.push(obj);
                })

                setDataRows(list);
            });
    }

    const [open, setOpen] = React.useState(false)
    useEffect(() => {
        //loadData();
        loadRestaurantData()
    }, [open])

    const columns = [
        {
            field: 'name', headerName: 'Name', align: 'center',
            renderCell: (params) =>
                <div className='d-flex align-items-center justify-content-center' style={{ gap: "5px", cursor: "pointer" }} onClick={() => { selectDataForEdit(params.value); setOpen(true) }} >
                    <span style={{ color: "blue", cursor: "pointer" }}>{params.value} </span>
                    <img src={pencilIcon} alt="" style={{ width: ".8rem" }} />
                </div>,
            headerAlign: 'center', flex: 1
        },
        // { field: 'address', headerName: 'Address', align: 'center', headerAlign: 'center', flex: 1 },
        { field: 'PhoneNumber', headerName: 'PhoneNumber', align: 'center', headerAlign: 'center', flex: 1 },
        { field: 'Email', headerName: 'Email', align: 'center', headerAlign: 'center', flex: 1 },
        {
            field: 'Action', headerName: 'Action', align: 'center',
            renderCell: (params) =>
                <Link to={`/orders-queue?kitchenId=${params.id}`} style={{ textDecoration: "none" }}>
                    <div className="d-flex">
                        <div
                            className="actionBackground"
                        //  onClick={() => handleClickOpen(params?.row.id, params?.row.items)}
                        >
                            <p>View Kitchen</p>
                        </div>
                    </div>
                </Link>,
            headerAlign: 'center', flex: 1
        },
    ];
    const [enableOptions, setEnableOptions] = React.useState(false);
    const [dataRows, setDataRows] = useState([])
    const [selectedDatas, setselectedDatas] = useState()

    const selectDataForEdit = (props) => {
        console.log(props);
        console.log(dataRows);
        var obj = dataRows.find(x => x.name == props);
        console.log(obj)
        setselectedDatas(obj.id)
    }


    const getselectedData = (props) => {
        var temp = props;
        if (props == "") {
            setEnableOptions(false);
        }
        else {

            setselectedDatas(props);
            setEnableOptions(true);
        }

    }
    console.log("selectedDatas", selectedDatas);

    const deleteBin = () => {

        var url = apiAddress + "/api/Kitchen/DeleteKitchen"
        axios
            .put(url, selectedDatas)
            .then((response) => {
                toast.success("successfully deleted", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });

                setopenConfirmaitonModal(false)
                loadData(selectedRes);
            })

        //loadData()

    }
    const errorToast = (msg) => {
        toast.error(msg, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }




    const openSetupModal = () => {
        setOpen(true)
    }
    const handleAddItem = (AddItemData) => {
        setOpen(AddItemData)
    }

    const [restaurantDataRows, setRestaurantDataRows] = useState([])

    const [value, setValue] = React.useState(0);

    const sliderRef = useRef(null);

    const handleNext = (swiperRef) => {
        swiperRef.current.swiper.slideNext();
    };

    const handlePrev = (swiperRef) => {
        swiperRef.current.swiper.slidePrev();
    };

    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
        console.log(newValue);
    };

    const [activeTab, setActiveTab] = useState(0);

    const handleTabClick = (index) => {
        setActiveTab(index);
    };

    const [selectedRes, setselectedRes] = useState();

    console.log("selectedRes", selectedRes)

    const onTabClick = (data) => {
        console.log("data", data)
        setselectedRes(data);
        // setDataRows([]);
        // loadFoodData(data);
        loadData(data)
        console.log("data", data);
    };

    const TabViewItem = ({ children, count, data }) => {
        console.log("count: " + count);
        console.log("value: " + value);

        return (
            <div
                onClick={() => {
                    onTabClick(data);
                }}
            >
                {<div>{children}</div>}
            </div>
        );
    };

    const loadRestaurantData = async () => {
        const token = localStorage.getItem("gotasteadmintoken");
        var decodedData = {};
        if (token != null) {
            try {
                decodedData = jwt_decode(token);

                var obj = {
                    id: decodedData.UserId,
                    title: decodedData.UserName,
                };
            } catch (error) { }
        }
        const restaurant = JSON.parse(localStorage.getItem("restaurant"));
        axios
            .get(
                apiAddress +
                "/api/Restaurant/getrestaurantdetailsbyidfortable/" +
                decodedData.UserId +
                "/" +
                restaurant.id
            )
            .then((response) => {
                console.log(response.data);
                var list = [];
                // list.push(response.data)
                // setRestaurantDatas(list);
                response.data.map((dt, i) => {
                    var obj = {
                        id: dt.id,
                        name: dt.name,
                        address: dt.addressLine1,
                        PhoneNumber: dt.phoneNumber,
                        Email: dt.emailAddress,
                        isActive: dt.isActive
                    };
                    list.push(obj);
                });

                setRestaurantDataRows(list);
                loadData(response.data[0])
                setselectedRes(response.data[0])
            });
    };

    return (
        <div>
            <div>
                {restaurantDataRows.length > 0 ? (
                    <div className="tabview">
                        <TabContext value={value}>
                            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                                <div className="slider-container">
                                    <button
                                        onClick={() => {
                                            handlePrev(sliderRef);
                                        }}
                                        className="arrow-btn-food"
                                    >
                                        <img src={LeftArrow} alt={"arrow"} />
                                    </button>
                                    <Swiper
                                        spaceBetween={10}
                                        slidesPerView={"auto"}
                                        ref={sliderRef}
                                    >
                                        <TabList
                                            onChange={handleChange}
                                            aria-label="lab API tabs example"
                                            variant="scrollable"
                                            scrollButtons="auto"
                                        >
                                            {restaurantDataRows.map((dt, i) => {
                                                return (
                                                    // <Tab label={dt.menuName} value={i} />
                                                    <SwiperSlide
                                                        key={i}
                                                        style={{ width: "auto" }}
                                                        className={i === activeTab ? "tab-active" : ""}
                                                    >
                                                        <Tab
                                                            className="p-0"
                                                            label={
                                                                <TabViewItem count={i} data={dt}>
                                                                    <div style={{ padding: '13px' }}>
                                                                        {dt.name}
                                                                    </div>
                                                                </TabViewItem>
                                                            }
                                                            value={i}
                                                            onClick={() => handleTabClick(i)}
                                                        />
                                                    </SwiperSlide>
                                                );
                                            })}
                                        </TabList>
                                    </Swiper>
                                    <button
                                        onClick={() => {
                                            handleNext(sliderRef);
                                        }}
                                        className="arrow-btn-food"
                                    >
                                        <img src={RightArrow} alt="arrow" />
                                    </button>
                                </div>
                            </Box>

                            {restaurantDataRows.map((dt, i) => {
                                return value == i ? (
                                    <>
                                        <FilterComponents title={"OK"} isItem={18} />
                                        <Grid
                                            container
                                            alignItems="center"
                                            justifyContent="space-between"
                                            mt={2}
                                            mb={2}
                                            style={{ width: '100%' }}
                                        >
                                            <SweetAlertModal
                                                headerText={"Are you sure?"}
                                                bodyText={"You want to delete this?"}
                                                open={openConfirmaitonModal}
                                                onyes={deleteBin}
                                                close={() => { setopenConfirmaitonModal(false) }}
                                            />

                                            <Grid item>
                                                <div className='roundedCorner'>
                                                    <img src={bin}
                                                        alt=""
                                                        style={{ width: '1rem' }}
                                                        onClick={() => { selectedDatas.length == 0 ? errorToast("Please select a row") : setopenConfirmaitonModal(true) }} />
                                                </div>
                                            </Grid>
                                        </Grid>

                                        <Paper>
                                            {dataRows.length > 0 ? (
                                                <CustomDataGrid
                                                    columns={columns}
                                                    dataRows={dataRows}
                                                    getselectedData={getselectedData}
                                                />
                                            ) : (
                                                "No Data Found"
                                            )}
                                        </Paper>
                                    </>
                                ) : (
                                    ""
                                );
                            })}
                        </TabContext>
                    </div>
                ) : (
                    <div className="mt-1">
                    </div>
                )}
            </div>
            {
                open ? (
                    <EditKitchenDialog open={open}
                        onHandleAddItem={handleAddItem}
                        title={props.title} isEdit={"true"} selectedId={selectedDatas} />
                ) : ""
            }

        </div>
    );
}

export default KitchenSetupPage;